import { render, staticRenderFns } from "./RoleLimitBadge.vue?vue&type=template&id=0248f2b2&scoped=true&"
import script from "./RoleLimitBadge.vue?vue&type=script&lang=js&"
export * from "./RoleLimitBadge.vue?vue&type=script&lang=js&"
import style0 from "./RoleLimitBadge.vue?vue&type=style&index=0&id=0248f2b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0248f2b2",
  null
  
)

export default component.exports